import React from "react";

const QuizAlertScreen = ({ readchapter, handleQuiz, quizbutton }) => {
  return (
    <div className="bg-white rounded-3 p-4 shadow mt-mb-20 mt-4 mb-5 quiz-alert-screen">
      <div className="d-flex justify-content-center">
        <div className="entry-screen text-align-center">
          <div className="logoText">
            <h3>You Completed the Section:</h3>
          </div>
          <h2 className="alert-heading">
            <span>
              {(() => {
                const currentTopic = JSON.parse(sessionStorage.getItem("currentTopic"));
                // Try to get section title from different possible structures
                const sectionTitle = currentTopic?.section?.title || 
                                    currentTopic?.section?.sections?.title || 
                                    "";
                return sectionTitle || `Section ${currentTopic?.topic_code || ""} "${currentTopic?.title || ""}"`;
              })()}
            </span>
          </h2>
          <h2 className="alert-para">
            but have not completed the quiz question for this section.
          </h2>
          <br />
          <div className="col-lg-12 col-md-12">
            <div className="d-flex justify-content-between mt-4 gap-4 quiz-alert-actions">
              <button
                className="btn btn-secondary-s text-white btn-md w-50 rounded-2"
                onClick={readchapter}
              >
                <i className="fa fa-angle-left me-1"></i> Go to beginning of section
              </button>
              <button
                className="btn course-start btn-primary-s text-white btn-md w-50 rounded-2"
                disabled={quizbutton}
                onClick={handleQuiz}
              >
                Go to quiz <i className="fa fa-angle-right ms-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile-only typography, spacing, and button size tweaks */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @media (max-width: 767.98px) {
              .quiz-alert-screen {
                font-size: 1rem;
                padding: 1.25rem;
                margin-top: 1rem;
                margin-bottom: 1.5rem;
              }
              .quiz-alert-screen h2,
              .quiz-alert-screen h3 {
                font-size: 1.2rem;
              }
              .quiz-alert-screen .btn {
                padding: 0.35rem 0.6rem;
                font-size: 1rem;
                margin-top: 0.5rem !important;
                margin-bottom: 0.5rem !important;
              }
              .quiz-alert-screen .mt-4 {
                margin-top: 0.85rem !important;
              }
              .quiz-alert-screen .quiz-alert-actions {
                flex-direction: column;
              }
              .quiz-alert-screen .quiz-alert-actions .btn {
                width: 100% !important;
              }
            }
          `,
        }}
      />
    </div>
  );
};

export default QuizAlertScreen;
